import React from 'react'
import ReactDOM from 'react-dom/client'
import './polyfill'
import './asset/style/index.css'
import './locales/index'
import App from './App'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<App />)
